import React from 'react'
import { useTranslation } from 'react-i18next'

import translationKeys from '@translationKeys'

import EmptyChatImage from '@assets/images/empty_chat.svg'
import Button from '@components/formControls/Button'
import { Typography } from '@mui/material'
import { useFeatureFlags } from '@shared/hooks/useFeatureFlags'

import { EmptyChatImageComponent, NoMessagesContainer } from './index.styles'

const REDIRECT_URL =
  'https://informaconnect.com/partneringone/plus?utm_source=referral&utm_medium=partnering%20one&utm_campaign=trigger&utm_term=link&utm_content=IAMEA02L&tracker_id=IAMEA02L'

const NoMessageItem = () => {
  const { t } = useTranslation()
  const { shouldUpgradeToPayingUser, cantInitiateChats } = useFeatureFlags()
  return (
    <NoMessagesContainer>
      <Typography variant="h2" sx={{ fontWeight: 500, textAlign: 'center' }}>
        {t(translationKeys.ONE_MAIL_PROMPT)}
      </Typography>
      <EmptyChatImageComponent src={EmptyChatImage} width="264px" height="264px" alt="empty" />
      {shouldUpgradeToPayingUser && (
        <Button variant="contained" color="primary" target="_blank" rel="noopener noreferrer" href={REDIRECT_URL}>
          {cantInitiateChats ? t(translationKeys.CLICK_HERE_TO_UPGRADE) : t(translationKeys.CLICK_HERE_TO_SUBSCRIBE)}
        </Button>
      )}
    </NoMessagesContainer>
  )
}

export default NoMessageItem
